import React, { useEffect, useState } from "react"
import axios from "axios"
import { useAuth } from "../contexts/AuthContext"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

// telas de uma empresa so: o superadmin escolhe a empresa e toda chamada da tela passa a levar ?cliente_id= (o servidor exige).
// Para os demais perfis nao muda nada.
export default function ComEmpresaSuper({ chave, children }: { chave: string; children: React.ReactNode }) {
  const { usuario } = useAuth() as any
  const superadmin = usuario?.perfil === "superadmin"
  const [clientes, setClientes] = useState<any[]>([])
  const [sel, setSel] = useState<string>(() => { try { return localStorage.getItem(`empresa_${chave}`) || "" } catch { return "" } })
  const [pronto, setPronto] = useState("")
  useEffect(() => {
    if (!superadmin) return
    axios.get(`${API}/clientes`).then((r) => setClientes(Array.isArray(r.data) ? r.data : [])).catch(() => {})
  }, [superadmin])
  useEffect(() => {
    if (!superadmin || !sel) { setPronto(""); return }
    const id = axios.interceptors.request.use((cfg) => { cfg.params = { ...(cfg.params || {}), cliente_id: sel }; return cfg })
    setPronto(sel)
    return () => { axios.interceptors.request.eject(id) }
  }, [superadmin, sel])
  if (!superadmin) return <>{children}</>
  const escolher = (v: string) => { setSel(v); try { localStorage.setItem(`empresa_${chave}`, v) } catch {} }
  return (
    <div style={{ padding: "16px 24px 0" }}>
      <label style={{ display: "block", fontSize: 12, opacity: 0.7, marginBottom: 4 }}>Empresa</label>
      <select aria-label="Empresa" value={sel} onChange={(e) => escolher(e.target.value)} style={{ minWidth: 260, maxWidth: "100%" }}>
        <option value="">— Escolha a empresa —</option>
        {clientes.map((c: any) => <option key={c.id} value={c.id}>{c.razao_social || c.nome_fantasia || c.id}</option>)}
      </select>
      {pronto && pronto === sel ? <React.Fragment key={sel}>{children}</React.Fragment> : <p style={{ opacity: 0.7, marginTop: 16 }}>Escolha a empresa para continuar.</p>}
    </div>
  )
}
